import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import FlexBox from 'components/common/FlexBox';
import { IconButton } from '@totalsoft/rocket-ui';

const ScoringCategoryItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/scoringCategories/${data.scoringId}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell>{data.orderNo}</TableCell>
      <TableCell>{data.code}</TableCell>
      <TableCell>{data.name}</TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton color='primary' size='small' variant='text' type='edit' tooltip={t('Edit')} onClick={handleEdit} />
          <IconButton
            color='primary'
            size='small'
            variant='text'
            type='delete'
            tooltip={t('Delete')}
            onClick={() => onDelete(data.scoringId)}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

ScoringCategoryItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ScoringCategoryItem;
